import * as fromActions from '../actions';
import * as fromModels from '../../models';
import { HttpHeaders } from '@angular/common/http';

export interface JobState {
  summary: SummaryState;
  summarySearch: SummarySearchState;
  selectedJobStatus: JobStatusDetailsState;
}

export interface SummarySearchState {
  loading: boolean;
  loaded: boolean;
  errors: any;
  searchCriteria: fromModels.LoadJobStatusListRequest;
}

export interface JobStatusDetailsState {
  loading: boolean;
  loaded: boolean;
  errors: any;
  jobStatus: fromModels.JobStatusResponse;
}

export interface SummaryState {
  loading: boolean;
  loaded: boolean;
  errors: any;
  response: fromModels.LoadJobStatusListResponse;
  searchCriteria: fromModels.LoadJobStatusListRequest;
  pagingSorting: fromModels.PagingSorting;
}

export const initialState: JobState = {
  summary: {
    loading: false,
    loaded: false,
    response: null,
    errors: null,
    searchCriteria: {
      fromDate: null,
      jobName: null,
      state: null,
      skip: null,
      sort: null,
      take: null,
      toDate: null
    },
    pagingSorting: {
      totalCount: null,
      pageSize: null,
      currentPage: null,
      totalPages: null,
      sortBy: null,
      sortDir: null
    }
  },
  summarySearch: {
    errors: null,
    loading: false,
    loaded: false,
    searchCriteria: {
      fromDate: null,
      jobName: null,
      state: null,
      skip: null,
      sort: null,
      take: null,
      toDate: null
    }
  },
  selectedJobStatus: {
    loading: false,
    loaded: false,
    errors: null,
    jobStatus: null
  }
};

export function reducer(state = initialState, action: fromActions.JobStatusActions): JobState {
  switch (action.type) {
    case fromActions.JobStatusActionTypes.ProcessQueryString: {
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          loaded: false,
          errors: null
        }
      };
    }
    case fromActions.JobStatusActionTypes.LoadJobStatusList: {
      console.log('LoadSummary', action.payload);
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          loaded: false,
          searchCriteria: action.payload
        }
      };
    }

    case fromActions.JobStatusActionTypes.LoadJobStatusListSuccess: {
      return {
        ...state,
        summary: {
          ...updateSearchResultsState(state.summary, action.payload, action.httpHeaders),
          loading: false,
          loaded: true
        }
      };
    }

    case fromActions.JobStatusActionTypes.LoadJobStatusListFailure: {
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: false,
          loaded: false,
          response: null,
          errors: action.payload
        }
      };
    }

    case fromActions.JobStatusActionTypes.LoadJobStatusDetails: {
      return {
        ...state,
        selectedJobStatus: {
          loaded: false,
          loading: true,
          errors: null,
          jobStatus: null
        }
      };
    }

    case fromActions.JobStatusActionTypes.LoadJobStatusDetailsSuccess: {
      return {
        ...state,
        selectedJobStatus: {
          ...state.selectedJobStatus,
          loading: false,
          loaded: true,
          errors: null,
          jobStatus: action.payload
        }
      };
    }

    case fromActions.JobStatusActionTypes.LoadJobStatusDetailsFailure: {
      return {
        ...state,
        selectedJobStatus: {
          ...state.selectedJobStatus,
          loading: false,
          loaded: true,
          errors: action.payload
        }
      };
    }

    case fromActions.JobStatusActionTypes.ExecuteSearch:
      return {
        ...state,
        summary: {
          ...state.summary,
          loading: true,
          loaded: false,
          searchCriteria: action.payload
        },
        summarySearch: {
          ...state.summarySearch,
          searchCriteria: action.payload
        }
      };

    case fromActions.JobStatusActionTypes.SortBy:
    case fromActions.JobStatusActionTypes.NextPage:
    case fromActions.JobStatusActionTypes.PrevPage:
    case fromActions.JobStatusActionTypes.FirstPage:
    case fromActions.JobStatusActionTypes.LastPage:
    case fromActions.JobStatusActionTypes.SetPageSize:
      return state;

    default: {
      if (Object.values(fromActions.JobStatusActionTypes).includes((action as fromActions.JobStatusActions).type)) {
        console.log('credit-report.reducer: unhandled action: ', action);
      }
    }
  }

  return state;
}

function updateSearchResultsState(state: SummaryState, response: fromModels.LoadJobStatusListResponse, headers: HttpHeaders) {
  let pagingSorting: fromModels.PagingSorting;

  // Grab special header we use for paging
  const pagingHeader: string = headers.get('X-Pagination');
  const pagingObject: object = JSON.parse(pagingHeader);

  // Populate paging information from http headers
  pagingSorting = {
    totalCount: pagingObject['totalCount'],
    pageSize: pagingObject['pageSize'],
    currentPage: pagingObject['currentPage'],
    totalPages: pagingObject['totalPages'],
    sortBy: pagingObject['sortBy'],
    sortDir: pagingObject['sortDir']
  };

  return {
    ...state,
    response,
    pagingSorting
  };
}

export const getJobStatusSummary = (state: JobState) => state.summary;
export const getJobStatusSummarySearch = (state: JobState) => state.summarySearch;
export const getJobStatusDetails = (state: JobState) => state.selectedJobStatus;
